/* eslint-disable */

export const protobufPackage = "tecton_proto.workflows";

/** Options indicating a state is terminal. */
export interface TerminalStateOptions {
  /** The termination status code for this state. See [WorkflowStateContainer.termination_code]. */
  termination_code?: TerminalStateOptions_WorkflowTerminationCode | undefined;
  retry_policy?: TerminalStateOptions_RetryPolicy | undefined;
}

/**
 * 0 is OK rather than UNSPECIFIED for backwards compatibility with gRPC codes, which were previously used.
 * Readers of TerminationCode fields should check hasFoo() to distinguish between unspecified and OK.
 */
export enum TerminalStateOptions_WorkflowTerminationCode {
  /** OK - The workflow completed successfully. */
  OK = "OK",
  /** CANCELLED - The workflow was cancelled. */
  CANCELLED = "CANCELLED",
  /** UNKNOWN_ERROR - A terminal error occurred, but we don't know exactly what it was. */
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

/**
 * Sub-options related to automatic retries for workflows that
 * terminate in this state.
 */
export interface TerminalStateOptions_RetryPolicy {
  /** Whether automatic retries are enabled. */
  enabled?: boolean | undefined;
}
